import React, { useState } from "react";


const departments = [
    { "name": "परिचय ", "id": "about" },
    { "name": "शोध परियोजनाएं", "id": "researchProjects" },
    { "name": "सेमीनार/सम्मेलन/कार्यशाला", "id": "seminarsWorkshops" },
    { "name": "शोधार्थी", "id": "researchScholars" },
    { "name": "उपलब्धियां", "id": "achievements" },
    { "name": "सम्पर्क", "id": "contact" }
];

const departmentContent = {
    "about": (
        <div>
            <h5 className="mb-3 text-center" style={{ color: "#77236b" }}>शोध केंद्र के बारे में</h5>
            <p className="mb-2 text-justify">मान्यवर सुविदित हो कि हरि की हरितिमा से सृजित हरिस्वरूप हरियाणा प्रान्त के कैथल (कपिष्ठलक्षेत्र) में हरियाणा सर्वकार के अधिनियम 20/2018 के द्वारा महर्षि वाल्मीकि संस्कृत विश्वविद्यालय स्थापित किया गया है, एवं विश्वविद्यालय अनुदान आयोग की धारा 2(F) से सम्बद्ध है। यह विश्वविद्यालय संस्कृत एवं संस्कृति संरक्षण हेतु सन्नद्ध है। यहाँ अङ्ग सहित आगम प्रतिष्ठित है, तो सामाजिक समसद्भाव हेतु सभी सङ्कल्पित हैं। प्राच्यविद्या एवं संस्कृति को समृद्ध करने की दिशा में महर्षि वाल्मीकि संस्कृत विश्वविद्यालय आरम्भ से ही अक्षुण्ण योगदान देता आ रहा है। यहाँ मुख्यतः वेद, व्याकरण, ज्योतिष, साहित्य, दर्शन, योग, वैदिक गणित, हिन्दू-अध्ययन विषय के शिक्षण की सम्यक् व्यवस्था के साथ – साथ कर्मकाण्ड विषयक सैद्धान्तिक एवं प्रायोगिक प्रशिक्षण की सुदृढ व्यवस्था है। प्राच्य विद्या के अन्तर्गत वेद, वेदाङ्ग, ब्राह्मण, श्रौतसूत्र, आरण्यक-आदि विषयों के अध्यापन द्वारा छात्रों को वैषयिक एवं प्रायोगिक ज्ञान प्रदान किया जाता है। विश्वविद्यालय के प्रमुख उद्देश्यों में से एक है: - हरियाणा प्रान्त में सरस्वती नदी के तट पर संवर्धित वैदिक सभ्यता एवं संस्कृति का राष्ट्रीय, अंतःराष्ट्रीय स्तर पर प्रामाणिक रूप से संस्थापन एवं प्रचार-प्रसार। विशेषरूप से कैथल (कपिष्ठल) जनपद की वैदिक परम्पराओं के संरक्षण एवं संवर्धन सम्बन्धी अकादमिक अनुष्ठानों का आयोजन करना।</p>
            <p className="mb-2 text-justify">उपर्युक्त उद्देश्य की सम्पूर्ति हेतु माननीय मुख्यमंत्री जी की संकल्पना का अनुपालन करते हुए महर्षि वाल्मीकि संस्कृत विश्वविद्यालय के द्वारा महर्षि कपिष्ठल की भूमि पर विद्वत परिषद् ने दिनांक 30-06-2022 को आयोजित पञ्चम् बैठक में कपिष्ठल-कठ संहिता शोध केन्द्र की स्थापना की अनुशंसा की।</p>
            <p className="mb-2 text-justify">यह शोध केन्द्र कृष्णयजुर्वेदीय कपिष्ठल-कठ संहिता के समग्र वैदिक साहित्य के अध्ययन व अनुसन्धान हेतु मार्गप्रशस्त करता है। इस शोध केन्द्र के आद्याधिष्ठाता माननीय कुलपति महोदय प्रो. रमेश चन्द्र भारद्वाज जी है। जिनके सत्प्रयत्न से यह अनुसन्धान केन्द्र शोधक्षेत्र में अग्रगण्य स्थान प्राप्त करेगा व वैदिक संस्कृति की पुनः स्थापना का मार्ग प्रशस्त करेगा।</p>
            <p className="mb-2 text-justify">वेदः शिवो शिवो वेदः वेदाध्यायी सदाशिवः, कलौ चण्डीमहेश्वरौ प्रकृत पदावली का तात्पर्य वेद के माहात्म्य को परिभाषित करते हुए मानव में देवभाव को स्थापित करता है। मनुष्य सदा अपने अभीष्ट प्राप्ति के लिए प्रयत्नशील रहता है परन्तु प्रतिबन्धक की अधिकता होने के कारण वह अपने इप्सित विषयों को प्राप्त नहीं कर पाता है। मानवीय अभीष्ट साधन के तौर पर भगवती श्रुति आविर्भूत हुई और सर्वत्र अन्न, वसन, स्वर्णप्रभृति पदार्थों को वितरण करती हुई शब्द समुदाय में लीन हो गई। वह भगवती का शाब्दिक समुदाय ही वेद कहलाता है। भारतीय संस्कृति का मूलाधार वैदिक शब्द सम्पदा है। जिसका चार वेदों के रूप में सम्पादन कृष्णद्वैपायन भगवान् वेदव्यास ने हरियाणा, विशेष रूप से कैथल के भौगोलिक क्षेत्र में किया।</p>
            <p className="mb-4 text-justify">कालान्तर में महर्षि कपिष्ठल के द्वारा प्रतिष्ठित-श्रुति कपिष्ठलप्रदेश में अनिष्टनिवारण एवम् इष्टप्राप्ति के लिए उपस्थिता भगवती कपिष्ठल-कठसंहिता कृष्णयजुर्वेदीय भाग के रूप में प्रसिद्ध हुई। सौभाग्यवश महर्षि वाल्मीकि संस्कृत विश्वविद्यालय कपिष्ठलप्रदेश में विराजमान है। हरयाणा (हरियाणा) ‘हर’ (शिव) के समाराधकों का प्रदेश है। जिसके अधिकांश गांवों में शिवालय स्थापित है। श्रावण मास में सम्पूर्ण हरियाणा शिवमय हो जाता है। जिसकी जड़ें वैदिक रुद्र (शिव) की उपासना में निहित है। भारतीय समाज की धार्मिक-परम्पराओं को वैदिक संस्कृति से जोडने हेतु विश्वविद्यालय के माननीय कुलपति महोदय, जो संस्कृति साधना के प्रति सिद्धसाधक के तौर पर प्रसिद्ध है।</p>

            <h6 className="mb-3 text-secondary">उद्देश्य:</h6>
            <ol className="list-group list-group-numbered mb-4">
                <li className="list-group-item bg-transparent border-0">वर्तमान में लुप्त कपिष्ठल-कठ संहिता के स्वरूप को पुनः प्रकाशित करना।</li>
                <li className="list-group-item bg-transparent border-0">कपिष्ठ-कठ संहितोक्त सामाजिक एवं धार्मिक परम्पराओं का विश्लेषण करना।</li>
                <li className="list-group-item bg-transparent border-0">व्यक्ति एवं समाज में नैतिक मूल्यों की स्थापना।</li>
                <li className="list-group-item bg-transparent border-0">यज्ञपात्रों के परिचायात्मक ज्ञान के साथ – साथ श्रौत एवं स्मार्त्त यज्ञों के सम्बन्ध में विस्तृत प्रशिक्षण देना।</li>
                <li className="list-group-item bg-transparent border-0">वैश्विक समस्याओं से सन्दर्भित पर्यावरण एवं प्रदूषण निवारण हेतु वैदिक समाधान का अनुसन्धानात्मक कार्य करना।</li>
                <li className="list-group-item bg-transparent border-0">यज्ञ के माध्यम से मङ्गलमयी परिस्थिति व सामूहिक भावना का विस्तार करना।</li>
                <li className="list-group-item bg-transparent border-0">हरियाणा प्रान्त की सरकार एवं जनता की अपेक्षाओं के अनुरूप विश्वविद्यालय को भारतीय वैदिक संस्कृति के अध्ययन, अध्यापन एवं शोध का सर्वोत्कृष्ट अकादमिक केन्द्र के रूप मे विकसित करना।</li>
                <li className="list-group-item bg-transparent border-0">मानवीय व्यवहार शुद्धि के लिए वैदिक - क्रियाकलापों का ज्ञान कराना।</li>
                <li className="list-group-item bg-transparent border-0">विविध प्रकोप के उपशमन में वेद-वर्णित उपचारों का ज्ञान कराना।</li>
                <li className="list-group-item bg-transparent border-0">पर्यावरण शुध्यर्थ वेदोक्त काष्ठों का ज्ञान कराना।</li>
            </ol>

            <h6 className="mb-3 text-secondary">शैक्षिक स्वरूप:</h6>
            <ul className="list-group list-group-flush mb-4">
                <li className="list-group-item bg-transparent border-0">1. वर्तमान में लुप्त कपिष्ठल-कठ संहिता के स्वरूप को पुनः प्रकाशित करना।</li>
                <li className="list-group-item bg-transparent border-0">2. कपिष्ठ-कठ संहितोक्त सामाजिक एवं धार्मिक परम्पराओं का विश्लेषण करना।</li>
                <li className="list-group-item bg-transparent border-0">3. कपिष्ठल-कठ संहिता में स्थित रुद्रस्वरूप का व्याख्यान करना।</li>
            </ul>

            <h6 className="mb-3 text-secondary">सामाजिक उद्देश्य:</h6>
            <ul className="list-group list-group-flush mb-4">
                <li className="list-group-item bg-transparent border-0">1. सामाजिक समरसता को स्थापित करना।</li>
                <li className="list-group-item bg-transparent border-0">2. पर्यावरणशुद्धि व प्राकृतिक चेतना को जीवन्त करना।</li>
                <li className="list-group-item bg-transparent border-0">3. व्यक्ति एवं समाज में नैतिक मूल्यों की स्थापना।</li>
                <li className="list-group-item bg-transparent border-0">4. मङ्गलमयी परिस्थिति व सामूहिक भावना का विस्तार करना।</li>
            </ul>

            <h6 className="mb-3 text-secondary">विश्वविद्यालयीय कर्त्तव्य:</h6>
            <p className="mb-2 text-justify">हरियाणा प्रान्त की सरकार एवं जनता की अपेक्षाओं के अनुरूप विश्वविद्यालय को भारतीय वैदिक संस्कृति के अध्ययन, अध्यापन एवं शोध का सर्वोत्कृष्ट अकादमिक केन्द्र के रूप मे विकसित करना।</p>
            <p className="mb-4 text-justify">उपर्युक्त कर्तव्यों को ध्यान में रखते हुए महर्षि वाल्मीकि संस्कृत विश्वविद्यालय द्वारा कपिष्ठल कठ संहिता शोध केन्द्र की स्थापना की गई है जिसके द्वारा कपिष्ठल-कठ संहिता के वैशिष्ट्य को जानकर समाज में इसके महत्त्व को प्रकाशित करें।</p>

            <h6 className="mb-3 text-secondary">कपिष्ठल-कठ संहिता शोध केन्द्र – स्थापना एवं उद्घाटन:</h6>
            <p className="mb-2 text-justify">महर्षि वाल्मीकि संस्कृत विश्वविद्यालय, कैथल के उद्धेश्यों की सम्पूर्ति हेतु विश्वविद्यालय की विद्वत परिषद् ने दिनांक 30-06-2022 को आयोजित पञ्चम् बैठक में कपिष्ठल-कठ संहिता शोध केन्द्र की स्थापना के प्रस्ताव की अनुशंसा की तथा विश्वविद्यालय के शैक्षणिक सत्र 2022-23 में “कपिष्ठल-कठ संहिता शोध केन्द्र” की स्थापना की गई है जिसका उद्घाटन दिनांक 17-02-2023 को विश्वविद्यालय के नूतन परिसर (टीक परिसर) में श्री भारत भूषण भारती, राजनैतिक सलाहकार, माननीय मुख्यमन्त्री हरियाणा सरकार के द्वारा किया गया।</p>
        </div>
    ),
    "researchProjects": (
        <div>
            <h5 className="mb-3 text-center" style={{ color: "#77236b" }}>शोध परियोजनाएं</h5>
            <h6 className="mb-3 text-secondary">कपिष्ठल-कठ संहिता शोध केन्द्र – सम्पादित कार्य:</h6>
            <ol className="list-group list-group-numbered mb-4">
                <li className="list-group-item bg-transparent border-0">माननीय कुलपति महोदय जी के आदेशानुसार कपिष्ठल-कठ संहिता शोध केन्द्र के लिए उपयोगी पुस्तक आचार्यरघुवीरसङ्कलित - कृष्णयजुर्वेदीया कपिष्ठलकठसंहिता का टंकन कार्य पूर्ण किया गया, जिसका प्रकाशन निकट भविष्य में अपेक्षित है।</li>
                <li className="list-group-item bg-transparent border-0">महाशिवरात्रि पर्व के पावन अवसर पर केन्द्र द्वारा विश्वविद्यालय के नूतन परिसर (टीक परिसर) में आमजनमानस एवं विश्वविद्यालयीय छात्रों को सामाजिक सद्भाव व नैसर्गिक अभीष्टसाधन के लिए कपिष्ठल-कठसंहिता के अन्तर्गत रूद्र पूजा के स्वरूप से अवगत कराने के उद्धेश्य से दिनांक 17/02/2023 एवं 18/02/2023 को कपिष्ठल-कठ संहिता में रूद्र पूजा का स्वरूप विषय पर दो दिवसीय राष्ट्रीय कार्यशाला का आयोजन किया गया, जिसमें देश के लब्धप्रतिष्ठित विद्वानों द्वारा सहभागिता की गई।</li>
                <li className="list-group-item bg-transparent border-0">सत्र 2022-23 में कुल 51,240/- रूपये (इक्यावन हजार दो सौ चालीस रूपये केवल) खर्च कर केन्द्र हेतु पुस्तकों की खरीद की गई।</li>
            </ol>

            <h6 className="mb-3 text-secondary">कपिष्ठल-कठ संहिता शोध केन्द्र - भविष्य की योजना:</h6>
            <ol className="list-group list-group-numbered">
                <li className="list-group-item bg-transparent border-0">वर्तमानपरिप्रेक्ष्य में नैतिक मूल्यों के ह्रास को रोकने के लिए षोडशसंस्कारों की भूमिका, जल समस्या से निदानार्थ वैदिकवाङ्मय का अनुशीलन, षोडशसंस्कार एवं अन्य धार्मिक अनुष्ठानों में वैज्ञानिक दृष्टि आदि विषयों पर शोध कार्य करना।</li>
                <li className="list-group-item bg-transparent border-0">आचार्यरघुवीरसङ्कलित - कृष्णयजुर्वेदीया कपिष्ठलकठसंहिता को प्रकाशित करवाना।</li>
                <li className="list-group-item bg-transparent border-0">केन्द्र से सम्बन्धित (कृष्णयजुर्वेद से सम्बन्धित) पुस्तकों के भण्डार को ओर अधिक समृद्ध करना।</li>
                <li className="list-group-item bg-transparent border-0">केन्द्र को यज्ञपात्रों से समृद्ध करना।</li>
            </ol>
        </div>
    ),
    "seminarsWorkshops": (
        <div>
            <h5 className="mb-3 text-center" style={{ color: "#77236b" }}>सेमीनार/सम्मेलन/कार्यशाला</h5>
            <ul className="list-group list-group-flush">
                <li className="list-group-item bg-transparent border-0">• दिनाङ्क 17-18 फरवरी 2023 को कपिष्ठल कठ संहिता शोध केन्द्र द्वारा कपिष्ठल-कठ संहिता में रुद्र पूजा का स्वरूप विषय पर द्विदिवसीया राष्ट्रीय कार्यशाला (ऑनलाइन/ऑफलाइन) का आयोजन महर्षि वाल्मीकि संस्कृत विश्वविद्यालय के टीक परिसर, कुरुक्षेत्र रोड़, कैथल में किया गया।</li>
            </ul>
        </div>
    ),
    "researchScholars": (
        <div>
            <h5 className="mb-3 text-center" style={{ color: "#77236b" }}>शोधार्थी</h5>
            <p className="text-muted">वर्तमान में कोई शोधार्थी पंजीकृत नहीं है।</p>
            {/* Add actual research scholar details if available */}
        </div>
    ),
    "achievements": (
        <div>
            <h5 className="mb-3 text-center" style={{ color: "#77236b" }}>उपलब्धियां</h5>
            <ul className="list-group list-group-flush">
                <li className="list-group-item bg-transparent border-0">• कपिष्ठल-कठसंहिता प्रकाशनाधीन।</li>
            </ul>
        </div>
    ),
    "contact": (
        <div>
            <h5 className="mb-3 text-center" style={{ color: "#77236b" }}>सम्पर्क</h5>

            {/* Academic Staff Contact */}
            <h6 className="mb-3 text-secondary">संकाय सदस्य (संयोजक)</h6>
            <div className="card mb-4 shadow-sm border-0">
                <div className="card-body p-3">
                    <p className="card-text mb-2">
                        <strong className="text-secondary">डॉ. अखिलेश कुमार मिश्र</strong><br />
                        सहायक-आचार्य<br />
                        उच्चतम योग्यता: पीएच.डी., नेट<br />
                    </p>
                </div>
            </div>

            <h6 className="mb-3 text-secondary">विभाग में कार्यरत शैक्षणिक कर्मचारियों का विवरण</h6>
            <div className="table-responsive mb-4">
                <table className="table table-bordered table-striped small">
                    <thead className="table-dark">
                        <tr>
                            <th>क्र.</th>
                            <th>नाम</th>
                            <th>पद</th>
                            <th>दूरभाष</th>
                            <th>ई-मेल</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1.</td>
                            <td>डॉ. अखिलेश कुमार मिश्र</td>
                            <td>संयोजक, कपिष्ठल कठ संहिता शोध केन्द्र</td>
                            <td><a href="tel:+917631274367" className="text-decoration-none text-dark fw-bold">7631274367</a></td>
                            <td><a href="mailto:kksrc@mvsu.ac.in" className="text-decoration-none text-dark fw-bold">kksrc@mvsu.ac.in</a></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* Non-Academic Staff Contact */}
            <h6 className="mb-3 text-secondary">विभाग में कार्यरत गैर-शैक्षणिक कर्मचारियों का विवरण</h6>
            <div className="table-responsive">
                <table className="table table-bordered table-striped small">
                    <thead className="table-dark">
                        <tr>
                            <th>क्र.</th>
                            <th>कर्मचारी का नाम</th>
                            <th>पद</th>
                            <th>दूरभाष</th>
                            <th>ई-मेल</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1.</td>
                            <td>श्री कुलवन्त सिंह</td>
                            <td>क्लर्क (HKRN)</td>
                            <td><a href="tel:+919729968584" className="text-decoration-none text-dark fw-bold">9729968584</a></td>
                            <td><a href="mailto:kksrc@mvsu.ac.in" className="text-decoration-none text-dark fw-bold">kksrc@mvsu.ac.in</a></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
};

export default function KathKapisthalaResearchCenter() {
    const [showSidebar, setShowSidebar] = useState(true);
    const [activeContentId, setActiveContentId] = useState("about"); // Set initial content

    const handleItemClick = (deptId) => {
        setActiveContentId(deptId);
        setShowSidebar(false); // Hide sidebar on click for small screens
    };

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">
            {/* Toggle Button for Small Screens */}
            <button
                className="btn d-md-none m-2 shadow-sm text-white"
                onClick={() => setShowSidebar(!showSidebar)}
                style={{
                    backgroundColor: "#77236b",
                    borderColor: "#77236b"
                }}
            >
                ☰ मेनू
            </button>



            {/* Sidebar */}
            <aside className={` text-white p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none d-md-flex"} col-md-3`}>
                <h5 className="text-center fw-bold mb-3 text-dark">कठ-कपिष्ठल शोध केंद्र</h5>
                <div className="flex-grow-1 overflow-auto">
                    {departments.map((dept) => (
                        <p
                            key={dept.id}
                            className={`mb-2 p-2 rounded shadow-sm small transition-all ${activeContentId === dept.id ? "text-white fw-bold" : "bg-white text-dark hover-effect"}`}
                            style={{
                                cursor: "pointer",
                                // Changed to purple color #77236b
                                backgroundColor: activeContentId === dept.id ? "#77236b" : "",
                            }}
                            onClick={() => handleItemClick(dept.id)}
                        >
                            {dept.name}
                        </p>
                    ))}
                </div>
            </aside>

            {/* Main Content */}
            <main className="flex-grow-1 p-3 bg-white shadow col-md-9 overflow-auto" onClick={() => setShowSidebar(false)}>
                {departmentContent[activeContentId] || <p className="text-muted">कृपया किसी अनुभाग का चयन करें।</p>}
            </main>
        </div>
    );
}
